export const beforeGameTypes = {
	SET_BEFORE_TAB: 'SET_BEFORE_TAB',
};

export const setBeforeGameTab = (payload) => ({
	type: beforeGameTypes.SET_BEFORE_TAB,
	payload,
});
